<br>

<div class="visits-table-wrapper">
    <app-common-list-table
        [request]="getRequest"
        [cols]="cols"
        [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform"
        [filtering]="filtering"
        [showExportCsv]="true">

        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center mb-0">Acciones</p>
            </th>
        </ng-template>
        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <div class="px-3">
                    <app-action-buttons
                        [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                        (showRowButtonEvent)="show('info', data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)">
                    </app-action-buttons>
                </div>
            </td>
        </ng-template>
        <ng-template #header>
            <div class="visits-filter-bar">
                <div class="visits-filter-control">
                    <span class="visits-filter-label">Semana</span>
                    <p-select
                        [options]="weeks"
                        [(ngModel)]="currentWeek"
                        optionLabel="name"
                        styleClass="visits-filter-select"
                        (onChange)="filterValues()"
                        appendTo="body">
                    </p-select>
                </div>
                <div class="visits-filter-control">
                    <span class="visits-filter-label">Año</span>
                    <p-select
                        [options]="years"
                        [(ngModel)]="currentYear"
                        optionLabel="name"
                        styleClass="visits-filter-select"
                        (onChange)="filterValues()"
                        appendTo="body">
                    </p-select>
                </div>
            </div>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>
